import { createAction, props } from '@ngrx/store';
import { CategoryEntity } from './categories.models';
import { FilterEntity } from '@frontend/data-access-documents';

export const initCategories = createAction(
  '[Filter Results Page] Init Categories',
  props<{ id?: number; language?: string }>(),
);
export const categoryPageOpened = createAction(
  '[Category Page] Page opened',
  props<{ id?: number; language?: string }>(),
);
export const updateId = createAction('[Filter Results Page] Update category ID', props<{ id: number | undefined }>());

export const loadCategoriesSuccess = createAction(
  '[Categories/Api] Get Categories Success',
  props<{ categories: CategoryEntity[] }>(),
);

export const loadCategoriesFailure = createAction('[Categories/Api] Get Categories Failure', props<{ error: any }>());

export const loadCategoryFilters = createAction(
  '[Category Page] Load Category Filters',
  props<{ language: string; id?: number }>(),
);

export const loadCategoryFiltersSuccess = createAction(
  '[Categories/Api] Load Category Filters Success',
  props<{ filters: FilterEntity[] }>(),
);

export const loadCategoryFiltersFailure = createAction(
  '[Categories/Api] Load Category Filters Failure',
  props<{ error: any }>(),
);
